/**************************************************
 * Nombre:       Tarjeta_Estado_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";

const Tarjeta_Estado_Envio = ({item, click}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000050',
                p: 2,
                color: '#000',
                borderRadius: 4
            }}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>Estado de envio</Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 0}}>
                <Typography sx={{fontSize: 14, fontWeight: 400}}>{`Pedido # ${item.consecutivo}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.3}}>
                <Typography sx={{fontSize: 12}}>{`Empresa de envio: ${item.empresaEnvio}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 12, lineHeight: 1.1}}> <span
                    style={{fontWeight: 600}}>Tiempo: </span>{item.tiempoEnvio + ' dias a partir del despacho de tu pedido'}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 6, md: 6}}
                sx={{mt: 1}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                    <Typography sx={{fontSize: 12, fontWeight: 600}}>Estado de envio</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>{item.estado}</Typography>
                </Grid>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Button onClick={() => click()} fullWidth sx={{pb: 1}}> Solicitar numero de Guia</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Estado_Envio